import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/QRCode/group";

export default class QrCodeGroupingService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
